<template>
  <v-row>
    <v-col cols="auto" class="pr-3">
      <BaseButton
        color="whiteSmoke"
        width="14"
        height="30"
        icon
        @click="previousStep"
      >
        <v-icon color="primary" size="14"> fa-chevron-left </v-icon>
      </BaseButton>
    </v-col>
    <v-col cols="10">
      <p class="gray--text" style="margin-top: 2px;">
        VOLTAR
      </p>
    </v-col>
    <v-col cols="12">
      <p class="gray--text font-weight-bold quotation-title mb-2">
        GRUPO ECONÔMICO E TOMADOR MATRIZ/FILIAL
      </p>
    </v-col>
    <v-col cols="12">
      <p
        class="primary--text font-weight-bold mb-2 quotation-select-company__text"
      >
        Grupo Econômico
      </p>
      <BaseSelect
        placeholder="Razão Social / CNPJ"
        v-bind="[$attrs, $props]"
        v-on="$listeners"
        :disabled="checkUser"
      />
    </v-col>
    <v-col cols="12">
      <p
        class="primary--text font-weight-bold mb-2 quotation-select-company__text"
      >
        Filtro Tomador Matriz/Filial
      </p>
      <BaseFilter
        v-model="filterTaker"
        :textPlaceholder="'Razão Social / CNPJ'"
        v-bind="defaultConfigs"
      />
    </v-col>
    <v-col cols="12" class="pb-6">
      <v-divider />
    </v-col>
  </v-row>
</template>
<script>
const defaultPropsFilter = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};
const mockListEconomicGroup = [
  "Snowman Labs - CNPJ 19.842.790/0001-80",
  "Empresa 1 - CNPJ 19.842.790/0001-80",
  "Empresa 2 - CNPJ 19.842.790/0001-80"
];
export default {
  data: () => ({
    listEconomicGroup: mockListEconomicGroup
  }),
  computed: {
    checkUser() {
      // TODO: criar uma regra para verificar o
      // nível de usuário. Se ele for comum,
      // ele terá apenas um grupo econômico
      // e portanto deve-se bloquear o campo de
      // seleção, caso contrário, deve-se deixar liberado
      return false;
    },
    defaultConfigs() {
      return {
        ...defaultPropsFilter
      };
    },
    filterTaker: {
      get() {
        return this.filter;
      },
      set(value) {
        this.$emit("updateFilter", value);
      }
    }
  },
  methods: {
    previousStep() {
      this.$emit("return");
    }
  },
  props: {
    filter: {
      type: String
    }
  }
};
</script>
<style lang="sass" scoped>
.quotation-select-company__text
  font-size: 14px
</style>
